import t from "./index911.js";
var o = t(Object.getPrototypeOf, Object);
export {
  o as default
};
